import React from 'react'

import { Header } from 'components/common'

export interface BenefitItemProps {
  imageSrc: string
  imageAlt: string
  title: string
  description: string
}

export const BenefitItem: React.FC<BenefitItemProps> = ({
  imageSrc,
  imageAlt,
  title,
  description,
}) => (
  <div className="benefit-item-container">
    <img src={imageSrc} alt={imageAlt} />
    <div className="benefit-item-info">
      <Header as="h4">{title}</Header>
      <div className="benefit-item-description">{description}</div>
    </div>
  </div>
)
